import styled from 'styled-components';

export const TitleSection = styled.div`
  position: relative;
  width: 100%;
  min-height: 58vh;
  overflow: hidden;

  @keyframes slideInFromLeft {
    0% {
      opacity: 0;
      transform: translateX(-32px);
    }

    100% {
      opacity: 1;
      transform: translateX(0);
    }
  }

  .overlay {
    position: absolute;
    inset: 0;

    background: linear-gradient(
      90deg,
      rgba(23, 23, 23, 0.86) 0%,
      rgba(23, 23, 23, 0.68) 42%,
      rgba(23, 23, 23, 0.28) 100%
    );
  }

  .overlay::after {
    content: '';

    position: absolute;
    inset: 0;

    background: radial-gradient(
      circle at 20% 30%,
      rgba(255, 210, 107, 0.16),
      transparent 30%
    );
  }

  img {
    position: absolute;
    inset: 0;

    width: 100%;
    height: 100%;

    object-fit: cover;
    object-position: center;

    opacity: 0.7;

    z-index: -1;
  }

  .text {
    position: relative;
    z-index: 2;

    min-height: 58vh;

    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: flex-start;

    max-width: 760px;

    padding: var(--space-xxxxl) var(--space-xxxl);

    animation: 0.7s ease-out 0s 1 slideInFromLeft;
  }

  .heroEyebrow {
    margin: 0 0 var(--space-m) 0;

    color: var(--yellow4);

    font-size: 0.8rem;
    font-weight: 900;

    text-transform: uppercase;
    letter-spacing: 0.16em;
  }

  .text h1 {
    margin: 0 0 var(--space-m) 0;

    color: var(--white);
    font-family: var(--headerFont);
    font-size: clamp(2.8rem, 6vw, 5.25rem);
    line-height: 0.95;
    font-weight: 900;
    text-transform: uppercase;
    letter-spacing: -0.04em;
  }

  .text,
  .text h1 .yellow {
    color: var(--yellow4);
    font-size: clamp(2.8rem, 6vw, 5.25rem);
    line-height: 0.95;
    font-weight: 900;
    font-family: var(--headerFont);
  }

  .heroSubtext {
    max-width: 620px;

    margin: 0 0 var(--space-xl) 0;

    color: rgba(255, 255, 255, 0.88);

    font-size: clamp(1rem, 1.4vw, 1.15rem);
    line-height: 1.75;
    font-weight: 500;
  }

  .heroActions {
    display: flex;
    flex-wrap: wrap;
    gap: var(--space-m);
  }

  @media screen and (max-width: 900px) {
    min-height: 52vh;

    .text {
      min-height: 52vh;
      padding: var(--space-xxxl) var(--space-xl);
    }
  }

  @media screen and (max-width: 700px) {
    min-height: 58vh;

    .text {
      min-height: 58vh;
      padding: var(--space-xxl) var(--space-m);
    }

    .heroActions {
      width: 100%;
      flex-direction: column;
      align-items: stretch;
    }

    button {
      width: 100%;
      max-width: 320px;
    }
  }

  @media screen and (min-width: 1500px) {
    min-height: 64vh;

    .text {
      min-height: 64vh;
    }
  }
`;
